import { render, staticRenderFns } from "./ClarifyReport.vue?vue&type=template&id=650415ff&"
import script from "./ClarifyReport.vue?vue&type=script&lang=js&"
export * from "./ClarifyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports